import { Alert } from "@station/ui";
import { createFileRoute } from "@tanstack/react-router";
import type { ReactElement } from "react";
import { useTranslation } from "react-i18next";
import { companySearchShape } from "../../../features/accounting/company.js";
import { ExpenseForm } from "../../../features/expenses/expense-form.js";
import { ExpensesPage, useExpensePermissions, useExpensesCrumb } from "../../../features/expenses/shared.js";
import { z } from "zod";

export const Route = createFileRoute("/_app/giderler/yeni")({
  validateSearch: (search) => z.object(companySearchShape).parse(search),
  component: NewExpensePage,
});

function NewExpensePage(): ReactElement {
  const { t } = useTranslation();
  const crumb = useExpensesCrumb("/giderler");
  const permissions = useExpensePermissions();
  return (
    <ExpensesPage
      title={t("expenses.list.new")}
      description={t("expenses.form.description")}
      breadcrumb={[crumb, { label: t("expenses.list.new") }]}
    >
      {({ companyId }) =>
        permissions.canManage ? (
          <ExpenseForm companyId={companyId} />
        ) : (
          <Alert tone="info">{t("expenses.form.noPermission")}</Alert>
        )
      }
    </ExpensesPage>
  );
}
